import Portfolio12 from './Portfolio12'
export default Portfolio12
